module.exports = __webpack_public_path__ + "static/media/imagepal.4e16748a.PNG";